import script from "./Id_card_finish.vue?vue&type=script&setup=true&lang=js"
export * from "./Id_card_finish.vue?vue&type=script&setup=true&lang=js"

import "./Id_card_finish.vue?vue&type=style&index=0&id=06fdea70&scoped=true&lang=css"

import exportComponent from "D:\\Git\\Nakhoncity\\Nakhoncity-App-Queue-Idcard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-06fdea70"]])

export default __exports__